import Swiper from 'swiper/bundle'

export default function SeriesSlider () {
  const WRAPPERS = document.querySelectorAll('.mtt-series-slider')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      createSlider(WRAPPERS[i])
    }
  }
}

function createSlider (WRAPPER) {
  const SWIPER_CONTAINER = WRAPPER.querySelector('.swiper-container')
  const PREV = WRAPPER.querySelector('.swiper-button-prev')
  const NEXT = WRAPPER.querySelector('.swiper-button-next')

  const SWIPER = new Swiper(SWIPER_CONTAINER, {
    slidesPerView: 1,
    speed: 800,
    spaceBetween: 40,
    freeMode: true,
    watchOverflow: true,
    preloadImages: false,
    lazy: true,
    navigation: {
      nextEl: NEXT,
      prevEl: PREV
    },
    breakpoints: {
      801: {
        slidesPerView: 2,
        spaceBetween: 24,
        freeMode: false
      },
      961: {
        slidesPerView: 2,
        spaceBetween: 40,
        freeMode: false
      }
    }
  })
}
